/** Promo automática del dueño no cuenta para tope/PIN; sí cuenta cajero, código y descuento sin promo. */

export type DiscountPinPromotion = {
  id: string;
  applyMode?: string | null;
};

export type DiscountPinApplied = {
  promotionId: string;
  discountAmount: number;
};

export type DiscountPinEvaluation = {
  discountTotal: number;
  lines: Array<{ appliedDiscounts: DiscountPinApplied[] }>;
  cartDiscounts: DiscountPinApplied[];
};

export function sumDiscretionaryDiscount(
  evaluation: DiscountPinEvaluation | null | undefined,
  promotions: DiscountPinPromotion[]
): number {
  if (!evaluation || evaluation.discountTotal <= 0) return 0;
  const modeById = new Map(promotions.map((p) => [p.id, p.applyMode ?? 'automatic']));
  let sum = 0;
  const add = (d: DiscountPinApplied) => {
    const mode = modeById.get(d.promotionId);
    if (mode === 'cashier_select' || mode === 'manual_code') {
      sum += Number(d.discountAmount) || 0;
    }
  };
  for (const line of evaluation.lines) {
    for (const d of line.appliedDiscounts) add(d);
  }
  for (const d of evaluation.cartDiscounts) add(d);
  return sum;
}

export function discountExceedsBranchCap(
  discretionaryTotal: number,
  subtotal: number,
  maxPercent: number,
  maxAmount: number
): boolean {
  if (discretionaryTotal <= 0) return false;
  const pct = subtotal > 0 ? (discretionaryTotal / subtotal) * 100 : 0;
  return discretionaryTotal > maxAmount || pct > maxPercent;
}

export type PosDiscountPinGate = 'allow' | 'require_pin';

export function resolvePosDiscountPinGate(input: {
  isOwner: boolean;
  canDiscount: boolean;
  discretionaryDiscountTotal: number;
  subtotal: number;
  maxPercent: number;
  maxAmount: number;
}): { gate: PosDiscountPinGate; overLimit: boolean } {
  const overLimit = discountExceedsBranchCap(
    input.discretionaryDiscountTotal,
    input.subtotal,
    input.maxPercent,
    input.maxAmount
  );
  if (input.isOwner) return { gate: 'allow', overLimit };
  if (input.discretionaryDiscountTotal <= 0) return { gate: 'allow', overLimit: false };
  if (input.canDiscount && !overLimit) return { gate: 'allow', overLimit: false };
  return { gate: 'require_pin', overLimit };
}
